import Entity from 'lib/Entity';

class Unread extends Entity {
  getUnreadCount() {
    return this.get('unread_count');
  }

  getParentId() {
    return this.get('parent');
  }

  incrementUnreadCount() {
    return this.set({ unread_count: this.get('unread_count') + 1 });
  }

  decrementUnreadCountBy(amount: number) {
    return this.set({ unread_count: Math.max(this.get('unread_count') - amount, 0) });
  }

  hasParent() {
    return this.get('parent') !== '';
  }

  defaults() {
    return {
      parent: '',
      unread_count: 0,
      timestamp: 0,
    };
  }
}

export default Unread;
